module.exports = __webpack_public_path__ + "img/arrow-circle.8b0d73ef.svg";